import React from "react";

export const SortIcon = (props) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="31"
            viewBox="0 0 31 31"
            {...props}
        >
            <g transform="translate(4029.266 -92.256) rotate(90)">
                <path
                    data-name="Path 896"
                    d="M95.85,4008.32h.829v13.3h1.659v-13.3h.829c.454,0,.829-.6.829-1.33s-.375-1.33-.829-1.33h-.829V4003H96.68v2.66H95.85c-.454,0-.829.6-.829,1.33S95.4,4008.32,95.85,4008.32Z"
                    transform="translate(1.235 1.646)"
                    fill="#336"
                />
                <path
                    data-name="Path 897"
                    d="M98.85,4016.3h.829v5.319h1.659V4016.3h.829c.454,0,.829-.6.829-1.331s-.375-1.33-.829-1.33h-.829V4003H99.68v10.64H98.85c-.454,0-.829.6-.829,1.33S98.4,4016.3,98.85,4016.3Z"
                    transform="translate(7.717 1.646)"
                    fill="#336"
                />
                <path
                    data-name="Path 898"
                    d="M101.85,4010.98h.829v10.639h1.659V4010.98h.829c.454,0,.829-.6.829-1.331s-.375-1.33-.829-1.33h-.829V4003H102.68v5.32h-.829c-.454,0-.829.6-.829,1.33S101.4,4010.98,101.85,4010.98Z"
                    transform="translate(14.199 1.646)"
                    fill="#336"
                />
            </g>
        </svg>
    );
};
